export enum COLOR_SCALES {
  "blueScale" = "blueScale",
  "pinkScale" = "pinkScale",
  "greenScale" = "greenScale",
  "successScale" = "successScale",
  "yellowScale" = "yellowScale",
  "warningScale" = "warningScale",
  "greyScale" = "greyScale",
  "redScale" = "redScale",
  "errorScale" = "errorScale",
}
export enum PRIMARY_COLOR_SCALES {
  "greyScale" = "greyScale",
  "blueScale" = "blueScale",
  "pinkScale" = "pinkScale",
}

export enum SECONDARY_COLOR_SCALES {
  "greenScale" = "greenScale",
  "successScale" = "greenScale",
  "yellowScale" = "yellowScale",
  "warningScale" = "yellowScale",
  "redScale" = "redScale",
  "errorScale" = "redScale",
}

export type TBaseColors = {
  primary: string;
  secondary: string;
  brand: string;
  background: string;
  muted: string;
  grey: string;
  pink: string;
  highlight: string;
  accent: string;
  green: string;
  blue: string;
  success: string;
  yellow: string;
  warning: string;
  red: string;
  error: string;
  text: string;
  descriptionText: string;
};

export type TColorScales = Record<keyof typeof COLOR_SCALES, string[]>;
export type TPrimaryColorScales = Record<
  keyof typeof PRIMARY_COLOR_SCALES,
  string[]
>;

export type TSecondaryColorScales = Record<
  keyof typeof SECONDARY_COLOR_SCALES,
  string[]
>;

export type IExtendedColors = TColorScales & TBaseColors;

export const primaryColorScales: TPrimaryColorScales = {
  greyScale: ["", "#F4F8FA", "#DCE3EE", "#9DABBE", "#5D697E", "#22252B"],
  blueScale: ["", "#c6e5eb", "#9ed3e0", "#52afc7", "#306783"],
  pinkScale: ["", "#FEEBF2", "#FFD1E8", "#C3006F", "#80004F"],
};

export const greenScale = ["", "#FCFDE5", "#F7F8C1", "#C9DC18", "#2D581D"];
export const successScale = greenScale;
export const redScale = ["", "#FFEDEB", "#FFCBC7", "#D92D20", "#A02211"];
export const errorScale = redScale;
export const yellowScale = ["", "#FFF8EA", "#FFE2B7", "#E17919", "#944B08"];
export const warningScale = yellowScale;

export const secondaryColorScales: TSecondaryColorScales = {
  greenScale,
  successScale,
  redScale,
  errorScale,
  yellowScale,
  warningScale,
};

export const colorScales: TColorScales = {
  ...primaryColorScales,
  ...secondaryColorScales,
};

export const baseColors: TBaseColors = {
  background: "#FFFFFF",
  primary: colorScales.blueScale[3],
  secondary: colorScales.pinkScale[3],
  brand: "#009CE0",
  pink: colorScales.pinkScale[3],
  grey: colorScales.greyScale[3],
  muted: colorScales.greyScale[1],
  accent: colorScales.greyScale[3],
  highlight: colorScales.greyScale[4],
  yellow: colorScales.yellowScale[3],
  warning: colorScales.warningScale[3],
  green: colorScales.greenScale[3],
  blue: colorScales.blueScale[3],
  success: colorScales.successScale[3],
  text: colorScales.greyScale[5],
  descriptionText: colorScales.greyScale[4],
  error: colorScales.errorScale[3],
  red: colorScales.redScale[3],
};

export const colors: IExtendedColors = {
  ...baseColors,
  ...colorScales,
};
